import { motion } from "framer-motion";
import Hero from "@/components/Hero";
import StatsBar from "@/components/StatsBar";
import Experiences from "@/components/Experiences";
import MediaGrid from "@/components/MediaGrid";
import Testimonials from "@/components/Testimonials";

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.5 } },
  exit: { opacity: 0, transition: { duration: 0.3 } },
};

export default function HomePage() {
  return (
    <motion.div
      data-testid="home-page"
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <Hero />
      <StatsBar />
      <Experiences />
      <MediaGrid />
      <Testimonials />
    </motion.div>
  );
}
